module.exports = __webpack_public_path__ + "static/media/indicationIcon.d1a91065.svg";